import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'manage-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="d-flex align-items-center btn-gap flex-wrap">
      @if(rowData.wishlistId == null){
        <button
        class="dp-secondary-btn btn-padding"
        (click)="onCellClick(rowData, 'like')">
          <div class="heart-div" style="background:var(--heart-icon-pm)"></div>
        </button>
        <button
        class="dp-secondary-btn btn-padding"
        (click)="onCellClick(rowData, 'wishlist')"
      >
        <div class="heart-div" style="background:var(--sticky-note)"></div>
        <!-- @if(rowData.wishlistId != null){
        <img src="../../assets/images/tick-gold.svg" />

        } -->
      </button>
      }
      
      @if(rowData.wishlistId != null){
        <button class="dp-secondary-btn btn-padding" [disabled]="rowData.isVisitedByMe===1"
        (click)="onCellClick(rowData, 'Add details')" [class.disabled]="rowData.isVisitedByMe===1">
          <span>Add visit</span>
          @if(rowData.isVisitedByMe===1){
            <div class="tick" style="background:var(--disc-tick)"></div>
          }
          <div class="heart-div" style="background:var(--location)"></div>
        </button>
        <button class="dp-secondary-btn btn-padding" [disabled]="rowData.visit_count===0"
        (click)="onCellClick(rowData, 'Visit history')" [class.disabled]="rowData.visit_count===0">
          <span>Visit history</span>
          @if(rowData.visit_count>0){
            <div class="visit-count">{{rowData.visit_count}}</div>
          }
          <div class="heart-div" style="background:var(--visit-history)"></div>
        </button>
      }
      <!-- <button
        class="dp-secondary-btn btn-padding"
        (click)="onCellClick(rowData, 'edit')"
      >
      <div class="heart-div" style="background:var(--edit)"></div>
      </button> -->
      <!--button class="dp-secondary-btn btn-padding d-flex align-items-center" (click)="onCellClick(rowData,'contact')">
      <img src="../../assets/images/contact-image-dark-gold.svg" />
      <span class="ms-2">Contact</span>
    </button -->
    </div>
  `,
  styles: [
    `.heart-div{
      height:24px;
      width:24px;
      background-repeat: no-repeat !important;
      background-size: contain !important;
      }
      .tick{
        height: 14px;width: 14px;
        position:absolute;top: 6px;right: 5px;
      }
      .visit-count{
        height: 16px;width: 16px;
        background-color: var(--text-secondary);
        outline: 3px solid var(--bg-primary);border-radius: 999px;
        font: 500 14px / 16px var(--manrope);color: var(--bg-primary);
        position: absolute;left: 22px;top: 6px;
      }

      .btn-gap {
        gap: 12px;
      }

      .btn-padding {
        position: relative;
        padding: 10px 8px 11px 8px;

        span{
          display: none;z-index: 9;
          position: absolute;top: -28px;left: -26px;
          height: fit-content;width: max-content;
          padding: 4px;border-radius: 4px;
          background-color: var(--text-tertiary);
          font: 400 16px / 18px var(--manrope);color: var(--bg-secondary);
        }
        &:hover span{
          display: block;
        }
      }

      .disabled{
        border: none;
        background-color: var(--input-focus);
      }
    `,
  ],
})
export class PrintAndMonitorCellComponent {
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();

  onCellClick(rowData: any, actionType: string) {
    this.cellClick.emit({ rowData, actionType });
  }

}
